import { OKRCategories } from './types/OKRCategories';
import { getMailboxTypeForBizchatTelemetry } from 'owa-bizchat-account-utils';
import { logCoreUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

/**
 * This file is for logging the new BizChat Copilot Chat side pane.
 */
type CopilotChatSidePaneTelemetryEvent =
    | 'CopilotSidePane_BizChatOpened'
    | 'CopilotSidePane_BizChatClosed'
    | 'CopilotSidePane_ExpandCollapseClicked'
    | 'CopilotSidePane_UserResized'
    | 'CopilotSidePane_StartingWidth';

const CopilotChatSidePaneScenario = 'BizChatSidePane';

function getOKRCategoryForEvent(event: CopilotChatSidePaneTelemetryEvent): OKRCategories {
    switch (event) {
        case 'CopilotSidePane_BizChatOpened':
            return OKRCategories.Seen;
        case 'CopilotSidePane_BizChatClosed':
            return OKRCategories.Closed;
        default:
            return OKRCategories.None;
    }
}

function getActionForEvent(event: CopilotChatSidePaneTelemetryEvent): string {
    switch (event) {
        case 'CopilotSidePane_BizChatOpened':
            return 'Seen';
        case 'CopilotSidePane_BizChatClosed':
            return 'Closed';
        default:
            return OKRCategories.None;
    }
}

export function logCopilotChatSidePaneTelemetryEvent(
    event: CopilotChatSidePaneTelemetryEvent,
    customData: {
        [key: string]: any;
    } = {},
    mailboxInfo?: MailboxInfo
): void {
    // TODO: Callers should pass the correct mailboxInfo. Fallback to getModuleContextMailboxInfo() is temporary.
    const mailbox = mailboxInfo || getModuleContextMailboxInfo();
    const canonicalTelemetryData = {
        Scenario: CopilotChatSidePaneScenario,
        OKRCategory: getOKRCategoryForEvent(event),
        Action: getActionForEvent(event),
        MailboxProvider: mailbox.mailboxProvider,
        MailboxType: getMailboxTypeForBizchatTelemetry(mailbox),
    };
    const legacyTelemetryData = {
        ...canonicalTelemetryData,
        ...customData,
    };

    logCoreUsage(
        'AIStandardTelemetry',
        mailbox,
        {
            CopilotEventName: event,
            ...legacyTelemetryData,
        },
        { isScorecardEvent: true }
    );

    logCoreUsage(
        'AIStandardTelemetry_BizChatSidePane',
        mailbox,
        {
            ...customData,
            ...canonicalTelemetryData,
            Action: event,
        },
        { isScorecardEvent: true }
    );
}
